var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('span',{staticClass:"loader__spinner",class:[("loader__spinner--" + _vm.size), ("loader__spinner--" + _vm.theme)]})])}
var staticRenderFns = []

export { render, staticRenderFns }